// extracted by mini-css-extract-plugin
export default {"container":"home_container__VvL0L","subtitles":"home_subtitles__J2P3X","fullstack":"home_fullstack__E+N7A","title":"home_title__ljgN5"};